<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-card
        v-if="ready"
        :raised="!searched"
        :flat="searched"
        tile
        class="large-search-card"
        ref="cardLarge"
      >
        <img
          class="background-image"
          :src="cardImg"
          :lazy-src="`${cardImg}?q=10`"
        >
        <figure
          v-if="!searched"
          class="top-card"
        >
       <!--   <v-img
            class="background-image"
            :height="cardImageHeight"
            :src="cardImg"
            :lazy-src="`${cardImg}?q=10`"
          >
          </v-img>-->
        </figure>

        <div
          :class="{
            'heading-container': true,
            'search-banner-text-color--text': true,
            'collapsed': searched
        }"
        >
          <h1 class="main-search-caption">
            {{ $gd.getText('search-banner-caption') }}
          </h1>
        </div>
        <v-card-text
          :class="searched ? 'card-text-large' : 'card-text-shrunk'"
        >
          <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
            <v-card
              raised
              :class="searched ? 'search-card-large' : 'search-card-shrunk'"
              tile
            >
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    lg="5"
                  >
                    <role-select
                      v-model="role"
                      :label="$t('Select Role')"
                      name="role"
                      outlined
                      @change="reset"
                    >

                    </role-select>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="5"
                    class="px-3"
                  >
                    <region-select
                      v-model="region"
                      :label="$t('Select Location')"
                      name="location"
                      outlined
                      @change="reset"
                    >

                    </region-select>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="2"
                  >
                    <primary-button
                      large
                      block
                      class="mt-1"
                      :loading="loading"
                      :disabled="invalid"
                      @click="onSubmit"
                    >
                      {{ $t('Search') }}
                    </primary-button>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">

  .top-card {
    position: absolute;
    width: 100%;
    transition:all 0.1s ease;
  }

  .background-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
  }

  .large-search-card {
    margin: 0;
    padding: 0;
    position: relative;
    transition:all 0.1s ease;
  }

  .heading-container {
    z-index: 1;
    position: relative;
    text-align: center;
    height: 350px;
    padding: 260px 20px 20px;
    transition:all 0.1s ease;

    &.collapsed {
      height: 0;
      padding: 0;
      overflow: hidden;
    }
  }

  .main-search-caption {
    text-shadow: 0 0 10px #000;
  }

  .card-text-large {
    padding: 0;
    transition:all 0.1s ease;
  }

  .card-text-shrunk {
    padding: 50px;
    transition:all 0.1s ease;
  }

  .search-card-large {
    padding: 25px 20px 0 20px;
  }

  .search-card-shrunk {
    padding: 25px 20px 0 20px;
  }

  .heading-container {
    z-index: 1;
  }

  .heading-container h1 {
    font-size: 50px;
  }



  /* Large Devices, Wide Screens */
  @media only screen and (max-width : 1200px) {

  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width : 992px) {

  }

  /* Small Devices, Tablets */
  @media only screen and (max-width : 768px) {

    .heading-container h1 {
      font-size: 30px;
      line-height: 35px;
    }

    .heading-container {
      text-align: center;
      height: 350px;
      padding: 260px 5px 5px;
      transition:all 0.1s ease;

      &.collapsed {
        height: 0;
        padding: 0;
        overflow: hidden;
      }
    }

    .card-text-shrunk {
      padding: 10px;
    }

  }

  /* Extra Small Devices, Phones */
  @media only screen and (max-width : 480px) {


  }

  /* Custom, iPhone Retina */
  @media only screen and (max-width : 320px) {

  }
</style>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import RegionSelect from '@/components/inputs/RegionSelect';
  import RoleSelect from '@/components/inputs/RoleSelect';

  export default {
    name: 'LargeSearchCard',
    props: {
      page: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        cardImageHeight: null,
      };
    },
    watch: {
      ready() {
        setTimeout(() => {
          this.updateCardImgHeight();
        });
      },
    },
    computed: {
      cardImg() {
        if (this.$vuetify.breakpoint.smAndDown) {
          return this.$gd.getThemeImages('search-banner-mobile');
        }

        return this.$gd.getThemeImages('search-banner');
      },
      role: {
        set(value) {
          this.updateForm({
            ...this.postForm,
            role_id: value,
          });
        },
        get() {
          return this.postForm.role_id;
        },
      },
      region: {
        set(value) {
          this.updateForm({
            ...this.postForm,
            region_id: value,
          });
        },
        get() {
          return this.postForm.region_id;
        },
      },
      ...mapGetters({
        posts: 'posts/posts',
        loading: 'posts/loading',
        searched: 'posts/searched',
        ready: 'posts/ready',
        postForm: 'posts/form',
      }),
    },
    methods: {
      ...mapActions({
        fetch: 'posts/fetch',
        initialized: 'posts/ready',
      }),
      ...mapMutations({
        updateForm: 'posts/updateForm',
      }),
      onSubmit() {
        this.fetch({
          form: this.postForm,
          pagination: {
            page: this.page,
          },
        });
      },
      reset() {
        if (this.page > 1) {
          this.$emit('update:page', 1);
        } else {
          this.onSubmit();
        }
      },
      updateCardImgHeight() {
        this.cardImageHeight = this.$refs.cardLarge.$el.offsetHeight;
      },
    },
    async mounted() {
      const { role_id, region_id } = this.postForm;

      if ((role_id || region_id) && this.posts.length === 0) {
        this.onSubmit();
      } else {
        this.initialized();
      }

      this.$watch('page', () => {
        this.onSubmit();
      });

      if (this.ready) {
        setTimeout(() => {
          this.updateCardImgHeight();
        });
      }
    },
    created() {
      window.addEventListener('resize', this.updateCardImgHeight);
    },
    destroyed() {
      window.removeEventListener('resize', this.updateCardImgHeight);
    },
    components: {
      RegionSelect,
      RoleSelect,
    },
  };
</script>

